import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import './styles/global.css'

// ResizeObserver 循环通知告警：Element Plus 表格/抽屉尺寸自适应时浏览器会抛，
// 属于浏览器自身的良性告警，不影响功能，这里拦掉避免污染控制台
window.addEventListener('error', (e) => {
  if (e && e.message && String(e.message).includes('ResizeObserver loop')) {
    e.stopImmediatePropagation()
  }
}, true)

const app = createApp(App)

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus, { locale: zhCn })
app.use(router)
app.mount('#app')
